import script from "./HomeAction.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeAction.vue?vue&type=script&setup=true&lang=js"

import "./HomeAction.vue?vue&type=style&index=0&id=377500c2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-377500c2"]])

export default __exports__